module.exports = __webpack_public_path__ + "static/media/blog7_2.7ee64c31.webp";